<template>
  <div class="report-container">
    <h3 class="page-title">个股信息</h3>

    <form @submit.prevent="handleSubmit" class="search-form">
      <!-- 搜索输入区 -->
      <div class="auto-complete-input vertical-spacing">
        <input
          type="text"
          v-model="searchQuery"
          @input="handleInput"
          @focus="showSuggestions = true"
          @blur="handleBlur"
          placeholder="请输入股票代码"
          class="input-field"
        />
        <ul v-if="showSuggestions && suggestions.length" class="suggestions-list">
          <li
            v-for="(suggestion, index) in suggestions"
            :key="index"
            @click="selectSuggestion(suggestion)"
            class="suggestion-item"
          >
            {{ suggestion }}
          </li>
        </ul>
      </div>

      <!-- 操作按钮组 -->
      <div class="button-group vertical-spacing">
        <button
          type="submit"
          :disabled="loading"
          class="submit-button"
        >
          {{ loading ? '加载中...' : '个股财报' }}
        </button>


        <button
          type="button"
          :disabled="loading"
          class="submit-button secondary-btn"
          @click="openInIframe('thscb')"
        >
          {{ loading ? '加载中...' : '同花顺财报' }}
        </button>

        <button
          type="button"
          :disabled="loading"
          class="submit-button secondary-btn"
          @click="openInIframe()"
        >
          {{ loading ? '加载中...' : '个股扫雷' }}
        </button>
        <button
          type="button"
          :disabled="loading"
          class="submit-button secondary-btn"
          @click="openInIframe('fhps')"
        >
          {{ loading ? '加载中...' : '个股分红' }}
        </button>

         <button
          type="button"
          :disabled="loading"
          class="submit-button secondary-btn"
          @click="openInIframe('thshot')"
        >
          {{ loading ? '加载中...' : '同花顺热榜' }}
        </button>
      </div>
    </form>

    <!-- 使用组件 -->
    <MobileIframeViewer
      v-if="showIframe"
      :show-iframe="showIframe"
      :iframe-src="iframeSrc"
      @close="closeIframe"
    />
  </div>
</template>

<script>
import MobileIframeViewer from '@/components/MobileIframeViewer.vue';
import { ElMessage } from 'element-plus';
import axios from 'axios';

export default {
  components: {
    MobileIframeViewer
  },
  data() {
    return {
      showIframe: false,
      iframeSrc: '',
      searchQuery: '',
      suggestions: [],
      showSuggestions: false,
      loading: false,
      formattedDate: '' // 新增变量（假设需要日期参数）
    };
  },
  methods: {
    handleInput() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        if (this.searchQuery.length >= 1) {
          this.fetchSuggestions(this.searchQuery);
        } else {
          this.suggestions = [];
        }
      }, 300);
    },
    handleBlur() {
      setTimeout(() => {
        this.showSuggestions = false;
      }, 200);
    },
    selectSuggestion(suggestion) {
      this.searchQuery = suggestion;
      this.suggestions = [];
      this.$emit('select', suggestion);
    },
    handleSubmit() {
      this.$emit('submit', this.searchQuery, this.formattedDate);
      this.viewReport(); // 直接调用查看方法
    },
    async fetchSuggestions(query) {
      try {
        const response = await axios.get('/api/stock_list', {
          params: { query }
        });
        this.suggestions = response.data;
      } catch (error) {
        console.error('获取数据失败:', error);
        ElMessage.error('股票代码检索失败，请重试');
      }
    },
    async viewReport() {

      if (!this.searchQuery) {
        ElMessage.warning('请输入股票代码');
        return;
      }
      this.loading = true;
      try {
         const scode = this.searchQuery.split(' ')[1].substring(0,6);
         this.iframeSrc = `https://x.cmschina.com/app/infomation/reportstock/#/?scode=${scode}&ecode=0&hideTitle=1`;
         this.showIframe = true;
      } finally {
        this.loading = false;
      }
    },
    openInIframe(type = 'report') {
      if(type === 'fhps'){
         const scode = this.searchQuery.split(' ')[1].substring(7,9)+this.searchQuery.split(' ')[1].substring(0,6);
         window.open(`https://xueqiu.com/snowman/S/${scode}/detail#/FHPS`);
      }
      else if(type === 'thshot'){
          window.open(`https://eq.10jqka.com.cn/frontend/thsTopRank/index.html?client_userid=kdfFz&back_source=wxhy&share_hxapp=isc&fontzoom=no#/`);
      }else if(type === 'thscb'){
          const scode = this.searchQuery.split(' ')[1].substring(0,6);
          window.open(`https://board.10jqka.com.cn/gateway/visual/searchResult?client_userid=kdfFz&back_source=wxhy&share_hxapp=isc&fontzoom=no#code=${scode}&type=2026-half&source=tssy`);
      }
      else{
          const scode = this.searchQuery.split(' ')[1].substring(0,6);
          window.open( `https://bowerbird.10jqka.com.cn/thslc/editor/view/433f6d9Ac0?back_source=wxhy&client_userid=kdfFz&code=${scode}&fontzoom=no&share_hxapp=isc`);

      }

    },
    closeIframe() {
      this.showIframe = false;
      this.iframeSrc = '';
    }
  }
};
</script>

<style scoped>


.page-title {
  font-size: 1.8rem;
  margin-bottom: 2rem;
  text-align: center;
  color: #333;
}

.vertical-spacing {
  margin-bottom: 1.5rem;
  width: 200px;
}

/* 表单容器样式 */
.search-form {
  width: 800px;
  margin: 0 auto 3rem;
  padding: 1.5rem;

}



.input-field {
  width: 100%;

  font-size: 1rem;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.input-field:focus {
  outline: none;
  border-color: #409eff;
  box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.2);
}

/* 下拉建议列表 */
.suggestions-list {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 0.3rem;
  padding: 0;
  list-style: none;
  background: white;
  border: 1px solid #e4e4e4;
  border-top: none;
  border-radius: 0 0 4px 4px;
  max-height: 220px;
  overflow-y: auto;
  z-index: 10;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.suggestion-item {
  padding: 0.6rem 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.suggestion-item:hover {
  background-color: #f5f7fa;
}

/* 按钮组样式 */
.button-group {
  display: flex;
  justify-content: space-between;
  gap: 1.2rem;
}

.submit-button {
  flex: 1;
  min-height: 44px;
  padding: 0.6rem 1rem;
  font-size: 1rem;
  font-weight: 500;
  border: none;
  border-radius: 6px;
  background-color: #409eff;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.secondary-btn {
  background-color: #rgba(64, 158, 255, 0.1);
  width: 140px;
}

.submit-button:disabled {
  background-color: #a0c4ff;
  cursor: not-allowed;
  box-shadow: none;
}

.submit-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* 移动端模拟容器 */
.mobile-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.85);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 1rem;
  box-sizing: border-box;
}

.iframe-wrapper {
  position: relative;
  min-width: 450px;
  max-width: 90%;
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  border: 8px solid #e0e0e0;
  margin-bottom: 1.5rem;
}

.mobile-iframe {
  width: 100%;
  height: 70vh;
  min-height: 500px;
  max-height: 90vh;
  border: none;
  display: block;
}

.close-btn {
  padding: 0.75rem 1.5rem;
  background: #409eff;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1rem;
  transition: all 0.3s ease;
  box-shadow: 0 2px 6px rgba(64, 158, 255, 0.3);
}

.close-btn:hover {
  background: #66b1ff;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
}

/* 响应式样式 */
@media (max-width: 768px) {
  .page-title {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .search-form {
    margin-bottom: 2rem;
    padding: 1rem;
  }

  .button-group {
    flex-direction: column;
    gap: 0.8rem;
  }

  .submit-button {
    min-height: 48px;
  }

  .iframe-wrapper {
    width: 95%;
    border-radius: 12px;
    border-width: 6px;
  }

  .mobile-iframe {
    height: 75vh;
  }
}

@media (max-height: 600px) {
  .mobile-iframe {
    min-height: 400px;
  }
}
</style>
